import { PREF } from 'core-cmp/Preferences'
import AlertDefinitionInfoPanel from 'thm/ui/common/alertDefinition/AlertDefinitionInfoPanel'
import ChildStache from 'thm/ui/common/alertDefinition/AlertDefinitionStatusAnomalyInfoPanel.stache'
import { APP } from 'core-uda/model/Resource'

/**
 * @class AlertDefinitionStatusAnomalyInfoPanel
 * Alert Definition "Status Anomaly" Form.
 */
let AlertDefinitionStatusAnomalyInfoPanel = AlertDefinitionInfoPanel.extend({
  id: 'AlertDefinitionStatusAnomalyInfoPanel',
  childTpl: ChildStache,
  timingAllowed: true,

  bindEvents: function () {
    let me = this
    me._super()
    PREF.bind('unitChanged', function (ev, newVal, oldVal) {
      me.updateViewModel()
    })
  },

  //override
  initViewModel: function () {
    let me = this
    me._super()
    me.viewModel.attr('statusOptions', APP('animal').getStatusOptions()) //TEMPORAIRE: on utilisera celui de herd une fois la ressource créée
  },
})
export default AlertDefinitionStatusAnomalyInfoPanel
